module.exports = __webpack_public_path__ + "static/media/Adventure capture.aca442cc.PNG";